import React from 'react'
import { BackHandler, Platform, Share } from 'react-native'

import { useFocusEffect, useRoute } from '@react-navigation/native'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import useCustomerStore from '@zet/customer/src/store'
import useMyCustomersStore from '@zet/customer/src/store/myCustomers'
import { B4, Icon, XStack, colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ArrowLeft from '@zet/design-system/svg/ArrowLeft'
import { useWebShare } from '@zet/feature-brands/hooks/useWebShare'
import { useUserContext } from '@zet/feature-user/api/user/hooks'
import { i18n } from '@zet/localization'

import { useGenerateShareLinkToAddCustomer } from '../../../api/addCustomer/hooks'

const EnterNameScreenHeader = () => {
  const navigation = useNavigation()
  const { WebShare, openWebShare } = useWebShare()
  const { params } = useRoute()
  const { setSelectedCustomer } = useCustomerStore()
  const { mutate } = useGenerateShareLinkToAddCustomer()
  const { partnerId } = useMyCustomersStore()

  const { data } = useUserContext()

  const handleShareLink = () => {
    if (partnerId) {
      mutate(
        {
          linkType: 'partnerShareLink',
          partnerId: partnerId,
          customerAdditionSource: params?.source,
        },
        { onSuccess: onShare }
      )
    } else {
      mutate(
        { linkType: 'globalShareLink', customerAdditionSource: params?.source },
        { onSuccess: onShare }
      )
    }
  }
  const onShare = async (response) => {
    if (Platform.OS === 'web') {
      await openWebShare({
        text: response?.data?.link || '',
      })
    } else {
      await Share.share({
        message: i18n.t('myCustomers.shareDescription', {
          link: response?.data?.link,
          name: data?.name,
        }),
      })
    }
  }

  const onPressBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate('HomeView')
    }
  }

  const addBackHandler = () => {
    const backAction = () => {
      setSelectedCustomer(null)
      navigation.goBack()
      return true
    }

    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction
    )

    return () => backHandler.remove()
  }

  useFocusEffect(
    React.useCallback(() => {
      const unsubscribe = addBackHandler()
      return () => unsubscribe()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  )
  return (
    <XStack className="bg-neutral-white100 px-1">
      <XStack className="w-full justify-between p-2">
        <Pressable
          className="bg-grays-20 h-5 w-5 items-center justify-center rounded"
          onPress={onPressBack}
        >
          <ArrowLeft color={'#050505'} />
        </Pressable>
        <Pressable onPress={handleShareLink}>
          <XStack className="mr-2 mt-2 justify-center">
            <Icon type="Share" color={zetColors.primary[100]} />
            <B4 className="text-primary-100 ml-1 mt-[2]">
              {i18n.t('knowCustomer.shareLink')}
            </B4>
          </XStack>
        </Pressable>
      </XStack>
      <WebShare />
    </XStack>
  )
}

export default EnterNameScreenHeader
